/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag", "Söndag"], a = ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"], n = "År", t = "År", s = "Månad", o = "Vecka", d = "Dagar", r = "Dag", c = "Idag", g = "Ingen händelse", l = "Heldag", M = "Ta bort", i = "Skapa händelse", u = "dddd den D MMMM YYYY", y = {
  weekDays: e,
  months: a,
  years: n,
  year: t,
  month: s,
  week: o,
  days: d,
  day: r,
  today: c,
  noEvent: g,
  allDay: l,
  deleteEvent: M,
  createEvent: i,
  dateFormat: u
};
export {
  l as allDay,
  i as createEvent,
  u as dateFormat,
  r as day,
  d as days,
  y as default,
  M as deleteEvent,
  s as month,
  a as months,
  g as noEvent,
  c as today,
  o as week,
  e as weekDays,
  t as year,
  n as years
};
